import { render, staticRenderFns } from "./UpdatesModal.template.html?vue&type=template&id=0392a080&scoped=true&external"
import script from "./UpdatesModal.vue?vue&type=script&lang=js"
export * from "./UpdatesModal.vue?vue&type=script&lang=js"
import style0 from "./UpdatesModal.style.scss?vue&type=style&index=0&id=0392a080&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0392a080",
  null
  
)

export default component.exports